import { SharePointListClient, type ListItem } from '../SharePointListClient';

/** 99.ABM_MediosDeContacto — source of "Cómo llegó a nosotros" options. */
export type MediosDeContactoFields = {
  Title?: string | null;
  Medio_MC?: string | null;
  Status_MC?: 'Activo' | 'Inactivo' | string | null;
};

export type MedioDeContactoItem = ListItem<MediosDeContactoFields>;

export const mediosDeContactoClient = new SharePointListClient<MediosDeContactoFields>(
  'ABM_MediosDeContacto',
);

export async function listAllMediosDeContacto(): Promise<MedioDeContactoItem[]> {
  return mediosDeContactoClient.listItems({ top: 5000 });
}

export async function listActiveMediosDeContacto(): Promise<MedioDeContactoItem[]> {
  return mediosDeContactoClient.listItems({
    filter: "fields/Status_MC eq 'Activo'",
    orderBy: 'fields/Medio_MC asc',
  });
}

export async function createMedioDeContacto(medio: string): Promise<MedioDeContactoItem> {
  return mediosDeContactoClient.createItem({
    Title: '[sumar]',
    Medio_MC: medio.trim(),
    Status_MC: 'Activo',
  });
}

export async function updateMedioDeContacto(
  id: string,
  medio: string,
): Promise<MedioDeContactoItem> {
  return mediosDeContactoClient.updateItem(id, { Medio_MC: medio.trim() });
}

export async function softDeleteMedioDeContacto(id: string): Promise<MedioDeContactoItem> {
  return mediosDeContactoClient.updateItem(id, { Status_MC: 'Inactivo' });
}
